import { JSX } from 'react';
import { Alert, AlertTitle, Badge, Button, Flex } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from "react-i18next";

type Props = {
  onDetailsClick: () => void;
};
export function DuplicatesAlert({ onDetailsClick }: Props): JSX.Element {
    const { t } = useTranslation('common');
  return (
    <Alert status="error" mb="4">
      <Flex width={'100%'} justifyContent="space-between" alignItems="center" gap={4}>
        <Flex alignItems="center" gap={3}>
          <Badge p={1} borderRadius="full" variant="solid" colorScheme="red">
            <FontAwesomeIcon size="sm" color="white" icon={faRotateExclamation} />
          </Badge>
          <AlertTitle>{t('common:potentialDuplicatesOnYourStudent')}</AlertTitle>
        </Flex>

        <Button variant="solid" onClick={onDetailsClick} flexShrink={0}>
          {t('common:details')}
                          </Button>
      </Flex>
    </Alert>
  );
}
